import axios from "axios";
import Api from "./../../Api";

const Service = {
  async get() {
    try {
      const data = {
        "MAIN_ACCOUNT_ID": localStorage.getItem("MAIN_ACCOUNT_ID"),
        "SUB_ACCOUNT_ID": localStorage.getItem("UserID")
      };

      const response = await axios.post(`${Api}/api/GET_ALL_SUB_ACCOUNT_USERS`,
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {

        return { success: true, data: response.data };
      } else if (response.status === 403) {
        localStorage.clear();
        window.location.reload();
      }
    } catch (error) {
      return { success: false, error };
    }
  },

  async post(data, link) {
    try {
      const response = await axios.post(
        `${Api}/api/${link}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );

      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (error) {
      return { success: false, error };
    }
  },


  async delete(id) {
    try {
      const data = {
        "USER_ID": id,
        "MAIN_ACCOUNT_ID": localStorage.getItem("MAIN_ACCOUNT_ID"),
        "SUB_ACCOUNT_ID": localStorage.getItem("UserID"),
      };


      const response = await axios.post(
        `${Api}/api/DELETE_SUB_ACCOUNT_USER`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (error) {
      return { success: false, error };
    }
  },
};

export default Service;
